/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useLayoutEffect } from "react";

import TestIds from "../testIds";

import { usePreviousPage } from "./usePreviousPage";

export const useScrollRestoration = <E extends HTMLElement = HTMLElement>({
  ref,
  scrollYPositionKey,
  path,
}: {
  ref: React.RefObject<E | null>;
  scrollYPositionKey: string;
  path: string;
}): void => {
  const { previousPage } = usePreviousPage();

  useLayoutEffect(() => {
    const clearTimer = setTimeout(() => {
      const element = document.getElementById(TestIds.pages.mainScrollContainer);
      if (element && scrollYPositionKey && previousPage.startsWith(path)) {
        element.scrollTo({
          top: parseInt(scrollYPositionKey) ?? 0,
          behavior: "auto",
        });
      }
    }, 100);

    return (): void => {
      clearTimeout(clearTimer);
    };
  }, [previousPage, ref]);
};
